import { render, staticRenderFns } from "./SettingsReservations.vue?vue&type=template&id=347a800c&scoped=true&"
import script from "./SettingsReservations.vue?vue&type=script&lang=js&"
export * from "./SettingsReservations.vue?vue&type=script&lang=js&"
import style0 from "./SettingsReservations.vue?vue&type=style&index=0&id=347a800c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a800c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/SettingsReservations.vue
// module id = null
// module chunks = 